import { DialogTheme } from '@/components/Dialog/theme';
import { tw } from '@/utils/tw';
import BasePostActionDialogTheme from 'base/components/PostActionDialog/theme';

const Dialog = tw.theme({
  extend: DialogTheme,
  slots: {
    base: ['bg-dodger-blue-300', 'border-t-4', 'border-logga-700', 'open:w-[420px]', 'open:md:w-[720px]'],
    contentWrapper: ['p-4', 'md:pb-4', 'gap-4'],
    content: ['text-content-sm'],
    headline: ['text-headline-lg'],
  },
});

const PostActionDialog = tw.theme({
  extend: BasePostActionDialogTheme,
});

export default Object.assign(PostActionDialog, {
  Dialog,
});
